// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2f7138c5","453":"8bd9ef81","796":"79c97290"}[chunkId] + ".chunk.js";
};